import { giphyDarkestGrey } from '@giphy/colors'
import styled from 'styled-components'
import { Alert as AlertComponent, Button as ButtonComponent } from 'ui'

export const Alert = styled(AlertComponent)`
    background: ${giphyDarkestGrey};
    border: none;
    width: 100%;
`

export const Button = styled(ButtonComponent)`
    display: inline-block;
    margin-right: 10px;
    width: 170px;

    &:last-child {
        margin-right: 0;
    }
`
